var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import querystring from "query-string";
import { getConfig } from "@jti/fe-common";
import calculateProductPoints from "../../../utils/calculateProductPoints";
import { sanitizeBaseUrl } from "../../../utils/evo/evo";
import sortByNumber from "../../../utils/sortByNumber";
import { Rest } from "../../Rest";
import { LoyaltyApiEvo } from "../LoyaltyApiEvo";
export class LoyaltyApiLegacy extends Rest {
    constructor(baseUrl, tenantToken) {
        super(baseUrl);
        this.tenantToken = tenantToken;
        this.name = "LoyaltyApi";
        this.setCommonHeader("X-DES-AK-TENANT-TOKEN", this.tenantToken);
    }
    getArticles({ uuid, ciam_token, idsParams }) {
        const options = {
            method: "GET",
        };
        if (uuid && ciam_token) {
            options.headers = { "X-DES-CONSUMER-IAM-TOKEN": ciam_token };
        }
        const urlExtension = (idsParams === null || idsParams === void 0 ? void 0 : idsParams.length) ? `?ids=${idsParams.join(",")}` : "";
        const url = uuid && ciam_token ? `/customer/${uuid}/articles` : `/articles`;
        return this.request(`${url}${urlExtension}`, options, true, false, this.getTimeoutValue())
            .then(({ data }) => data)
            .catch((err) => {
            console.error(err);
            throw err;
        });
    }
    getStatus() {
        return this.request("/status", {
            method: "GET",
        }, false, true, this.getTimeoutValue())
            .then((response) => response.isLoyaltyActive)
            .catch(() => false);
    }
    getPoints(uuid, ciam_token, useLocalCache = true) {
        const failureObject = {
            points: 0,
            expire_at: "",
            pending_points: 0,
            points_to_expire: 0,
        };
        return this.request(`/points?uuid=${uuid}`, {
            headers: { "X-DES-CONSUMER-IAM-TOKEN": ciam_token },
            method: "GET",
        }, false, useLocalCache, this.getTimeoutValue())
            .then((response) => {
            if (response === null || response === void 0 ? void 0 : response.points) {
                return response;
            }
            return failureObject;
        })
            .catch(() => failureObject);
    }
    getProductPoints(sku = "", quantity = 1, uuid = null, ciam_token = null) {
        const failureObject = {
            rules: [],
            points: 0,
            time_limited: false,
            time_to: "",
        };
        const requestURI = uuid && ciam_token ? `/customer/${uuid}/product/${sku}/points` : `/product/${sku}/points`;
        const options = ciam_token ? { headers: { "X-DES-CONSUMER-IAM-TOKEN": ciam_token } } : {};
        return this.request(requestURI, options, true, true, this.getTimeoutValue())
            .then((response) => {
            var _a;
            if (((_a = response === null || response === void 0 ? void 0 : response.rules) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                return {
                    points: calculateProductPoints(response.rules, quantity),
                    rules: response.rules,
                    time_to: response.time_to,
                    time_limited: response.time_limited,
                };
            }
            return failureObject;
        })
            .catch(() => failureObject);
    }
    getEligibleCampaigns(uuid, ciam_token, order) {
        return this.request(`/customers/${uuid}/eligible-campaigns`, Object.assign({ headers: { "X-DES-CONSUMER-IAM-TOKEN": ciam_token }, method: "POST" }, (order && { body: JSON.stringify({ order: order }) })), true, false, this.getTimeoutValue())
            .then((response) => (response ? sortByNumber(response.data, "price") : []))
            .catch(() => []);
    }
    getPointsHistory(consumer_uuid, ciam_token, perPage = 10, page = 1) {
        return (this.request(`/customers/${consumer_uuid}/points/history?perPage=${perPage}&page=${page}`, {
            headers: { "X-DES-CONSUMER-IAM-TOKEN": ciam_token },
            method: "GET",
        }, false, false, this.getTimeoutValue())
            // FIXME: Type casting
            .then((response) => response)
            // FIXME: how can error be correct response?
            .catch((response) => response));
    }
    getReferralHistory(consumer_uuid, ciam_token, perPage = 5, page = 1) {
        return this.request(`/customers/${consumer_uuid}/events/referrer?perPage=${perPage}&page=${page}`, {
            headers: { "X-DES-CONSUMER-IAM-TOKEN": ciam_token },
            method: "GET",
        }, true, false, this.getTimeoutValue())
            .then((response) => response)
            .catch((response) => {
            return response;
        });
    }
    getTiers() {
        return this.request(`/tiers`, {
            headers: { "X-DES-AK-TENANT-TOKEN": this.tenantToken },
        }, false, false, this.getTimeoutValue());
    }
    getUserTierData(consumer_uuid, ciam_token) {
        return this.request(`/profile/${consumer_uuid}`, {
            headers: { "X-DES-AK-TENANT-TOKEN": this.tenantToken, "X-DES-CONSUMER-IAM-TOKEN": ciam_token },
        }, true, false, this.getTimeoutValue());
    }
    getEarnedPoints(order_id, ciam_token) {
        return this.request(`/orders/${order_id}`, {
            headers: { "X-DES-CONSUMER-IAM-TOKEN": ciam_token, "X-DES-AK-TENANT-TOKEN": this.tenantToken },
            method: "GET",
        }, true, false, this.getTimeoutValue())
            .then((response) => response.points)
            .catch(() => 0);
    }
    getPrizes(payload) {
        const requestURI = `/prizes`;
        const queryParamsStringified = querystring.stringify(payload);
        const fullRequestURI = queryParamsStringified ? requestURI.concat("?", queryParamsStringified) : requestURI;
        return this.request(fullRequestURI, { method: "GET" }, true, false, this.getTimeoutValue());
    }
    buyPrize(consumer_uuid, prize_uuid, qty, ciam_token) {
        return this.request(`/prizes/buy`, {
            headers: { "X-DES-CONSUMER-IAM-TOKEN": ciam_token, "X-DES-AK-TENANT-TOKEN": this.tenantToken },
            method: "POST",
            body: JSON.stringify({
                consumer_uuid,
                prize_uuid,
                qty,
            }),
        }, true, false, this.getTimeoutValue());
    }
    getEarningRulePoints(event_name, ciam_token, user_uuid) {
        return this.request(`/earningRules/${event_name}?uuid=${user_uuid}`, {
            method: "GET",
            headers: { "X-DES-CONSUMER-IAM-TOKEN": ciam_token, "X-DES-AK-TENANT-TOKEN": this.tenantToken },
        }, true, false, this.getTimeoutValue())
            .then(({ points_amount }) => points_amount)
            .catch(() => 0);
    }
    getUserTier(consumer_uuid, ciam_token) {
        return this.request(`/customer/${consumer_uuid}/tier`, {
            headers: { "X-DES-CONSUMER-IAM-TOKEN": ciam_token, "X-DES-AK-TENANT-TOKEN": this.tenantToken },
            method: "GET",
        }, true, true, this.getTimeoutValue());
    }
    getQrCodeDetails({ qrCodeId, ciam_token }) {
        return this.request(`/qr-code/${qrCodeId}`, {
            headers: { "X-DES-CONSUMER-IAM-TOKEN": ciam_token, "X-DES-AK-TENANT-TOKEN": this.tenantToken },
            method: "GET",
        }, true, false, this.getTimeoutValue());
    }
    readArticleAction(article_id, ciam_token) {
        return this.request("/articles/read", {
            headers: { "X-DES-CONSUMER-IAM-TOKEN": ciam_token },
            method: "POST",
            body: JSON.stringify({
                article_id,
            }),
        }, true, false, this.getTimeoutValue());
    }
    scanQrAction(qr_id, ciam_token) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.request("/qr-code/read", {
                headers: { "X-DES-CONSUMER-IAM-TOKEN": ciam_token },
                method: "POST",
                body: JSON.stringify({
                    qr_id,
                }),
            }, true, false, this.getTimeoutValue());
            return res;
        });
    }
    getAchievements(uuid, ciam_token) {
        return this.request(`/achievements/${uuid}`, {
            headers: { "X-DES-CONSUMER-IAM-TOKEN": ciam_token },
            method: "GET",
        }, true, false, this.getTimeoutValue());
    }
    getReward(prize_uuid) {
        return __awaiter(this, void 0, void 0, function* () {
            const _a = getConfig(), { EVO_DOMAIN, EVO_TENANT } = _a, config = __rest(_a, ["EVO_DOMAIN", "EVO_TENANT"]);
            if (!EVO_DOMAIN || !EVO_TENANT) {
                throw new Error("Missing required configuration for getReward");
            }
            const evo = new LoyaltyApiEvo(sanitizeBaseUrl(EVO_DOMAIN), EVO_TENANT, config["X-RECAPTCHA-ID"]);
            return yield evo.getReward(prize_uuid);
        });
    }
    getTimeoutValue(defaultTimeout = 5000) {
        var _a;
        let timeout = defaultTimeout;
        const timeoutConfig = parseInt((_a = getConfig()) === null || _a === void 0 ? void 0 : _a.LOYALTY_REQUEST_TIMEOUT, 10);
        if (!isNaN(timeoutConfig)) {
            timeout = timeoutConfig;
        }
        return timeout;
    }
    getContestStatus(uuid, ciam_token) {
        return __awaiter(this, void 0, void 0, function* () {
            const _a = getConfig(), { EVO_DOMAIN, EVO_TENANT } = _a, config = __rest(_a, ["EVO_DOMAIN", "EVO_TENANT"]);
            if (!EVO_DOMAIN || !EVO_TENANT) {
                throw new Error("Missing required configuration for Contest");
            }
            const evo = new LoyaltyApiEvo(sanitizeBaseUrl(EVO_DOMAIN), EVO_TENANT, config["X-RECAPTCHA-ID"]);
            return yield evo.getContestStatus(uuid, ciam_token);
        });
    }
    postContest(uuid, ciam_token, contestSubmitData) {
        return __awaiter(this, void 0, void 0, function* () {
            const _a = getConfig(), { EVO_DOMAIN, EVO_TENANT } = _a, config = __rest(_a, ["EVO_DOMAIN", "EVO_TENANT"]);
            if (!EVO_DOMAIN || !EVO_TENANT) {
                throw new Error("Missing required configuration for Contest");
            }
            const evo = new LoyaltyApiEvo(sanitizeBaseUrl(EVO_DOMAIN), EVO_TENANT, config["X-RECAPTCHA-ID"]);
            return yield evo.postContest(uuid, ciam_token, contestSubmitData);
        });
    }
}
//# sourceMappingURL=LoyaltyApiLegacy.js.map